import "./dettaglioServizio.css";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, useParams } from "react-router-dom";
import { doulaActions } from "../../../store/doulaSlice";
import { elencoservizi } from "../../../config/elencoservizi.js";
import { MdArrowForwardIos } from "react-icons/md";
import { MdArrowBackIos } from "react-icons/md";
import React, { useState } from "react";
import feedbacks from "../../../config/feedbacks.json";

import { Helmet } from "react-helmet";

export const DettaglioServizio = () => {
    const { servizio } = useSelector((state) => state.doula);
    const params = useParams();
    const dispatch = useDispatch();
    const index = params.dettaglio;

    useEffect(() => {
        const currentService = elencoservizi.filter((el) => el.index == index);
        dispatch(doulaActions.replaceServizio(currentService[0]));
    }, [params]);

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex === feedbacks[params.dettaglio].length - 1 ? 0 : prevIndex + 1));
        }, 10000);

        return () => clearInterval(timer);
    }, [feedbacks[params.dettaglio].length]);

    const handlePrevClick = () => {
        setActiveIndex((prevIndex) => (prevIndex === 0 ? feedbacks[params.dettaglio].length - 1 : prevIndex - 1));
    };

    const handleNextClick = () => {
        setActiveIndex((prevIndex) => (prevIndex === feedbacks[params.dettaglio].length - 1 ? 0 : prevIndex + 1));
    };

    return (
        <>
            <title>
                <Helmet> Dettaglio Servizio</Helmet>
            </title>
            <section id="dettaglioServizio" className="pb-5 bgCream">
                <h2 className="fs-1 text-center py-5 textBlue">{servizio.title}</h2>
                <div className="container flex-grow-1 relative">
                    {window.screen.width > 500 && (
                        <NavLink
                            className="arrow-right"
                            to={
                                parseInt(index) == elencoservizi.length - 1
                                    ? "/servizi/0"
                                    : "/servizi/" + (parseInt(index) + 1)
                            }
                        >
                            <MdArrowForwardIos />
                        </NavLink>
                    )}

                    {window.screen.width > 500 && (
                        <NavLink
                            className="arrow-left"
                            to={
                                parseInt(index) == 0
                                    ? "/servizi/" + parseInt(elencoservizi.length - 1)
                                    : "/servizi/" + (parseInt(index) - 1)
                            }
                        >
                            <MdArrowBackIos />
                        </NavLink>
                    )}

                    <div className=" flex-row-reverse d-flex row">
                        <div className=" col-12 col-md-6 pb-4 ps-md-3 pt-md-3 widthDynamic margin-center pt-lg-0">
                            <img className="immagine-lettura" src={servizio.img} alt="" />
                        </div>

                        <div className="col-12 col-md-6 textBlue">
                            {servizio.text}
                            <h5 className="textBlue mt-5">
                                Sei interessata al servizio? Scrivimi senza problemi, trovi i miei contatti{" "}
                                <a href="/contatti" className=" textBlue underline-none">
                                    qui
                                </a>
                            </h5>
                        </div>
                    </div>

                    {/* Carousel Fatto da CHATGPT */}
                    <div className="try mb-5">
                        <h4 className="textBlue mt-5 text-center">Cosa pensano le mamme del servizio?</h4>
                        <div className="feedback-slider-container">
                            <div className="feedback-slider">
                                <div
                                    className="feedback-slider__arrow feedback-slider__arrow--left"
                                    onClick={handlePrevClick}
                                >
                                    <MdArrowBackIos />
                                </div>
                                <div
                                    className="feedback-slider__arrow feedback-slider__arrow--right"
                                    onClick={handleNextClick}
                                >
                                    <MdArrowForwardIos />
                                </div>
                                {feedbacks[params.dettaglio].map((feedback, index) => (
                                    <div
                                        key={index}
                                        className={`feedback-slider__text d-flex flex-column justify-content-center ${
                                            index === activeIndex ? "feedback-slider__text--active" : ""
                                        }`}
                                    >
                                        {feedback.text}
                                        <p
                                            className={`feedback-slider__author ${
                                                index === activeIndex ? "feedback-slider__author--active" : ""
                                            }`}
                                        >
                                            {feedback.author}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
